import { render, staticRenderFns } from "./OrderForm.vue?vue&type=template&id=27db9aa3&"
import script from "./OrderForm.vue?vue&type=script&lang=js&"
export * from "./OrderForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports